import { render, staticRenderFns } from "./groupAddress.vue?vue&type=template&id=38a8f7c2&scoped=true&"
import script from "./groupAddress.vue?vue&type=script&lang=js&"
export * from "./groupAddress.vue?vue&type=script&lang=js&"
import style0 from "./groupAddress.vue?vue&type=style&index=0&id=38a8f7c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a8f7c2",
  null
  
)

export default component.exports